import React, { useState, useRef } from 'react';
import {
  Grid,
  GridColumn,
  Button,
  Header,
  Image,
  Container,
} from 'semantic-ui-react';

export default function Gallery() {
  const allImages = [
    { src: 'brownMetalGate.webp', alt: 'Custom brown metal driveway gate, Launceston' },
    { src: 'roofRack.webp', alt: 'Custom black metal roof rack for ute, Launceston' },
    { src: 'structuralSteelwork2.webp', alt: 'Structural steelwork construction, Launceston' },
    { src: 'vehicleRack.webp', alt: 'Custom metal vehicle rack for ute, Launceston' },
    { src: 'metalDrain2.webp', alt: 'Metal drain installed on brick building, Launceston' },
    { src: 'solidBlackMetalGate.webp', alt: 'Custom black metal security gate, Launceston' },
    { src: 'pushSprayer.webp', alt: 'Custom metal push sprayer, Launceston' },
    { src: 'drivewayMetalGate.webp', alt: 'Custom metal driveway gate, Launceston' },
    { src: 'metalTimberStorageUnit.webp', alt: 'Custom metal and timber storage unit, Launceston' },
  ];

  const [visibleImages, setVisibleImages] = useState(3);
  const [showMore, setShowMore] = useState(true);
  const [b1Hovered, setB1Hovered] = useState(false);
  const galleryRef = useRef(null);

  const handleShowMore = () => {
    setVisibleImages(allImages.length);
    setShowMore(false);
  };

  const handleShowLess = () => {
    setVisibleImages(3);
    setShowMore(true);

    if (galleryRef.current) {
      galleryRef.current.scrollIntoView({ behavior: 'instant', block: 'start' });
    }
  };

  const imageStyle = {
    width: '100%',
    height: 'auto',
  };

  const buttonStyle = {
    color: '#FFFFFF',
    fontSize: '1em',
    backgroundColor: 'transparent',
    border: 'solid 0.1em #FFFFFF',
    borderRadius: '3em',
    padding: '0.6em 3em 0.6em 3em',
    transition: 'padding 0.5s ease',
    fontFamily: "'Lato', sans-serif",
    fontWeight: '400',
  };

  const buttonStyleHover = {
    ...buttonStyle,
    padding: '0.6em 4em 0.6em 4em',
    transition: 'padding 0.5s ease',
  };

  const containerStyle = {
    backgroundColor: 'transparent',
  };

  const h2Style = {
    fontFamily: "'B612', sans-serif",
    fontWeight: '400',
    color: '#FFFFFF',
    fontSize: 'clamp(2.7em, 3.5vw, 3.7em)',
    lineHeight: 'clamp(1.1em, 1.1vw, 1.3em)',
    padding: '0em 0em 0.5em 0em',
  };

  return (
    <div ref={galleryRef}>
      <Header as="h2" content="Our Highlights" style={h2Style} />
      <Grid doubling stackable centered columns={3}>
        {allImages.slice(0, visibleImages).map((image, index) => (
          <GridColumn key={index}>
            <Container style={containerStyle}>
              <Image
                src={image.src}
                alt={image.alt}
                srcSet={`${image.src} 320w, ${image.src} 768w, ${image.src} 1200w`}
                sizes="(max-width: 600px) 480px, (max-width: 1200px) 800px, 1200px"
                style={imageStyle}
                loading="lazy"
              />
            </Container>
          </GridColumn>
        ))}
      </Grid>
      <div style={{ textAlign: 'center', marginTop: '2em' }}>
        {showMore ? (
          <Button
            content="Show More"
            aria-label="Show more custom metal fabrication images"
            onClick={handleShowMore}
            onMouseEnter={() => setB1Hovered(true)}
            onMouseLeave={() => setB1Hovered(false)}
            style={b1Hovered ? buttonStyleHover : buttonStyle}
          />
        ) : (
          <Button
            content="Show Less"
            aria-label="Show fewer custom metal fabrication images"
            onClick={handleShowLess}
            onMouseEnter={() => setB1Hovered(true)}
            onMouseLeave={() => setB1Hovered(false)}
            style={b1Hovered ? buttonStyleHover : buttonStyle}
          />
        )}
      </div>
    </div>
  );
}